import React from 'react';
import Section from '../components/Section';
import DropdownField from '../components/DropdownField';
import TextField from '../components/TextField';

const DELIVERY_OPTIONS = [
  'No issues',
  'App went offline or outlet marked unavailable',
  'Rider didn\'t show',
  'Wrong order picked up',
  'Customer complaint via platform',
  'Payout or deduction query',
];

function S7_DeliveryPlatforms({ data, onChange }) {
  return (
    <Section title="Delivery platforms">
      <DropdownField
        label="Any issues with Zomato or Swiggy today?"
        options={DELIVERY_OPTIONS}
        value={data.delivery_platform}
        onChange={(v) => onChange('delivery_platform', v)}
        placeholder="Select (optional)"
      />

      <TextField
        label="Any details?"
        value={data.platform_notes || ''}
        onChange={(v) => onChange('platform_notes', v)}
        multiline
        maxLength={200}
        placeholder="Optional — add any details here"
      />
    </Section>
  );
}

export default S7_DeliveryPlatforms;
